// Widget components
export { MultiSelectWidget } from './MultiSelectWidget';
export { SelectWidget } from './SelectWidget';
export { ButtonGroupWidget } from './ButtonGroupWidget';
export { ConfirmWidget } from './ConfirmWidget';
export { FollowUpTags } from './FollowUpTags';
export { SuggestedActions } from './SuggestedActions';

// Note: Import widget types directly from '../../types/api'
// - ApiMultiSelectWidget, ApiSelectWidget
// - ApiButtonGroupWidget
// - ApiWidgetOptionGroup, ApiWidgetOption
// - ApiButtonConfig

// Widget registration utility
import { chatWidgetRegistry } from '../../types/widgets';
import { MultiSelectWidget } from './MultiSelectWidget';
import { SelectWidget } from './SelectWidget';
import { ButtonGroupWidget } from './ButtonGroupWidget';
import { ConfirmWidget } from './ConfirmWidget';

/**
 * Register all built-in chat widgets
 * Call this during app initialization
 */
export const registerDefaultChatWidgets = (): void => {
  if (!chatWidgetRegistry.has('multi_select')) {
    chatWidgetRegistry.register({
      widgetType: 'multi_select',
      component: MultiSelectWidget,
      displayName: 'Multi-Select Widget',
    });
  }

  if (!chatWidgetRegistry.has('select')) {
    chatWidgetRegistry.register({
      widgetType: 'select',
      component: SelectWidget,
      displayName: 'Select Widget',
    });
  }

  if (!chatWidgetRegistry.has('button_group')) {
    chatWidgetRegistry.register({
      widgetType: 'button_group',
      component: ButtonGroupWidget,
      displayName: 'Button Group Widget',
    });
  }

  if (!chatWidgetRegistry.has('confirm')) {
    chatWidgetRegistry.register({
      widgetType: 'confirm',
      component: ConfirmWidget,
      displayName: 'Confirm Widget',
    });
  }
};
